/**
 * Menü hover'da route chunk'ını önceden yükler (2025/2026 best practice).
 * Aynı import path'leri App.js'deki lazy() ile paylaşılır; webpack aynı chunk'ı kullanır.
 */
import ROUTES from "./routes";

const preloaded = new Set();

const loaders = {
  [ROUTES.DASHBOARD]: () => import("./Pages/Dashboard"),
  [ROUTES.USERS]: () => import("./Pages/Users"),
  [ROUTES.AUTHORIZED_USERS]: () => import("./Pages/AuthorizedUsers"),
  [ROUTES.DRIVERS]: () => import("./Pages/Drivers"),
  [ROUTES.TRIPS]: () => import("./Pages/Trips"),
  [ROUTES.TRIP_LOGS]: () => import("./Pages/LiveRides"),
  [ROUTES.OPERATIONAL_METRICS_OVERVIEW]: () => import("./Pages/Metrics/Overview"),
  [ROUTES.OPERATIONAL_METRICS_DRIVERS]: () => import("./Pages/Metrics/DriverMetrics"),
  [ROUTES.OPERATIONAL_METRICS_PASSENGERS]: () => import("./Pages/Metrics/PassengerMetrics"),
  [ROUTES.OPERATIONAL_METRICS_PERFORMANCE]: () => import("./Pages/Metrics/PerformanceReport"),
  [ROUTES.OPERATIONAL_METRICS_COVERAGE]: () => import("./Pages/Metrics/CoverageHeatmap"),
  [ROUTES.OPERATIONAL_METRICS_ACCEPTANCE_CANCELLATION]: () => import("./Pages/Metrics/AcceptanceCancellationReport"),
  [ROUTES.OPERATIONAL_METRICS_DRIVER_PENALTIES]: () => import("./Pages/DriverPenalties"),
  [ROUTES.LOCATION_SMART_MAP]: () => import("./Pages/SmartMap"),
  [ROUTES.LOCATION_ACTIVE_DRIVERS]: () => import("./Pages/ActiveDrivers"),
  [ROUTES.COMMUNICATION_CHAT]: () => import("./Pages/ChatApp"),
  [ROUTES.COMMUNICATION_NOTIFICATIONS]: () => import("./Pages/NotificationSend"),
  [ROUTES.COMMUNICATION_BULK_SMS]: () => import("./Pages/BulkSms"),
  [ROUTES.CUSTOMER_MESSAGES]: () => import("./Pages/CustomerMessages"),
  [ROUTES.CRM]: () => import("./Pages/Crm"),
  [ROUTES.PAYMENTS_BANK_TRANSFER]: () => import("./Pages/BankTransferPayments"),
  [ROUTES.SUBSCRIPTIONS_DRIVERS]: () => import("./Pages/DriverSubscriptions"),
  [ROUTES.SUBSCRIPTIONS_AUDIT_LOGS]: () => import("./Pages/SubscriptionAuditLogs"),
  [ROUTES.SUBSCRIPTIONS_STATISTICS]: () => import("./Pages/SubscriptionStatistics"),
  [ROUTES.SETTINGS_GENERAL]: () => import("./Pages/Settings"),
  [ROUTES.SETTINGS_REGION]: () => import("./Pages/Region"),
  [ROUTES.SETTINGS_VEHICLE_TYPES]: () => import("./Pages/VehicleTypes"),
  [ROUTES.SETTINGS_DISTANCE_DISCOUNTS]: () => import("./Pages/DistanceDiscounts"),
  [ROUTES.SETTINGS_SUBSCRIPTION_PLANS]: () => import("./Pages/SubscriptionPlans"),
  [ROUTES.SETTINGS_DRIVER_DISCOUNTS]: () => import("./Pages/DriverDiscounts"),
  [ROUTES.SETTINGS_AGREEMENTS]: () => import("./Pages/Agreements"),
  [ROUTES.SETTINGS_SYSTEM_LOGS_SMS]: () => import("./Pages/SmsLogs"),
  [ROUTES.SETTINGS_FAQ]: () => import("./Pages/Faq"),
  [ROUTES.SETTINGS_PAGES]: () => import("./Pages/Pages"),
  [ROUTES.SETTINGS_BANK_ACCOUNTS]: () => import("./Pages/BankAccounts"),
};

/**
 * Verilen path için route chunk'ını önceden yükler (hover'da çağrılır).
 * Zaten yüklenmiş path'ler tekrar çağrılmaz.
 */
export function preloadRoute(path) {
  if (!path || preloaded.has(path)) return;
  const loader = loaders[path];
  if (loader) {
    preloaded.add(path);
    loader().catch(() => preloaded.delete(path));
  }
}

/** Sık kullanılan route'ları idle'da önceden yükler (ilk tıklamada gecikmeyi azaltır) */
const CRITICAL_PATHS = [
  ROUTES.USERS,
  ROUTES.DRIVERS,
  ROUTES.TRIPS,
  ROUTES.OPERATIONAL_METRICS_OVERVIEW,
];
export function preloadCriticalRoutes() {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(() => CRITICAL_PATHS.forEach(preloadRoute), { timeout: 2000 });
  } else {
    setTimeout(() => CRITICAL_PATHS.forEach(preloadRoute), 1500);
  }
}
